import React from 'react';
import { useDispatch } from 'react-redux';
import { deleteStore, fetchStores } from '../../../../redux/storesSlice';
import { notifySuccess, notifyError } from '../../../Notification';
import './accessStoreControl.css';

const DeleteStoreModal = ({ store, onClose }) => {
    const store_id = store.store_id;
    const store_name = store.name;
    const business_id = store.business_id;

    const dispatch = useDispatch();

    const handleDelete = () => {
        if (!store_id || !business_id) {
            notifyError('Missing store or business information.');
            return;
        }

        dispatch(deleteStore({ store_id }))
            .unwrap()
            .then(() => {
                notifySuccess(`Store "${store_name}" deleted successfully.`);
                dispatch(fetchStores(business_id));
                onClose();
            })
            .catch((error) => {
                notifyError(error || 'Failed to delete store.');
            });
    };

    return (
        <div>
            <div className="delete-user-business-warning-text">
                Are you sure you want to delete store <strong>{store_name}</strong>?
            </div>
            <div className="delete-users-business-buttons-container">
                <button className="delete-user-business-delete-btn" onClick={handleDelete}>
                    Delete
                </button>
                <button className="delete-user-business-cancel-btn" onClick={onClose}>
                    Cancel
                </button>
            </div>
        </div>
    );
};

export default DeleteStoreModal;
